/* global angular, moment */
/**
 * Created by lari on 08/06/2017.
 */
(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name rlog.service:Rlog
   *
   * @description
   *
   */
  angular
    .module('vcutils.printhelper')
    .service('PrintHelper', PrintHelper);

  PrintHelper.$inject = ['$http', '$log'];

  function PrintHelper($http, $log) {
    // Aides
    // router.get("/" + model + "/aide/:isprint/:ispersist/:patientid/:consultid").blockingHandler(this::referralHandler);
    this.aidePreviewUrl = function (patientid, consultid) {
      return `/routes/fop/aide/false/false/${patientid}/${consultid}`;
    };

    this.aidePrint = function (patientid, consultid) {
      let url = `/routes/fop/aide/true/true/${patientid}/${consultid}`;
      return $http.get(url);
    };

    this.aidePersist = function (patientid, consultid) {
      let url = `/routes/fop/aide/false/true/${patientid}/${consultid}`;
      return $http.get(url);
    };

    this.aideSinglePrint = function (patdocid, patientid) {
      let url = `/routes/fop/aidesingle/true/true/${patdocid}/${patientid}`;
      return $http.get(url);
    };

    // Referrals
    // router.get("/" + model + "/referral/:isprint/:ispersist/:patientid/:consultid").blockingHandler(this::referralHandler);
    this.referralPreviewUrl = function (patientid, consultid) {
      return `/routes/fop/referral/false/false/${patientid}/${consultid}`;
    };

    this.referralPrint = function (patientid, consultid) {
      let url = `/routes/fop/referral/true/true/${patientid}/${consultid}`;
      return $http.get(url);
    };

    this.referralPersist = function (patientid, consultid) {
      let url = `/routes/fop/referral/false/true/${patientid}/${consultid}`;
      return $http.get(url);
    };

    this.referralSinglePrint = function (patdocid, patientid) {
      let url = `/routes/fop/referralsingle/true/true/${patdocid}/${patientid}`;
      return $http.get(url);
    };

    this.referralSinglePreview = function (patdocid, patientid) {
      let url = `/routes/fop/referralsingle/false/false/${patdocid}/${patientid}`;
      return $http.get(url);
    };

    // Exam
    // router.get("/" + model + "/exam/:isprint/:ispersist/:examid/:consultid").blockingHandler(this::examHandler);

    this.examPreviewUrl = function (examid, consultid) {
      return `/routes/fop/exam/false/false/${examid}/${consultid}`;
    };

    this.examPrint = function (examid, consultid) {
      let url = `/routes/fop/exam/true/true/${examid}/${consultid}`;
      return $http.get(url);
    };

    this.examPersist = function (examid, consultid) {
      let url = `/routes/fop/exam/false/true/${examid}/${consultid}`;
      return $http.get(url);
    };

    // ExamSample
    // router.get("/" + model + "/examsample/:isprint/:ispersist/:examid").blockingHandler(this::examSampleHandler);
    this.examSamplePreviewUrl = function (examid) {
      return `/routes/fop/examsample/false/false/${examid}`;
    };

    // Examlabels
    // router.get("/" + model + "/examlabels/:isprint/:ispersist/:examid").blockingHandler(this::examlabelsHandler);

    this.examlabelsPreviewUrl = function (examid) {
      return `/routes/fop/examlabels/false/false/${examid}`;
    };

    this.examlabelsPrint = function (examid) {
      let url = `/routes/fop/examlabels/true/true/${examid}`;
      return $http.get(url);
    };

    this.examlabelsPersist = function (examid) {
      let url = `/routes/fop/examlabels/false/true/${examid}`;
      return $http.get(url);
    };

    // Consult
    // router.get("/" + model + "/consult/:isprint/:ispersist/:consultid").blockingHandler(this::consultHandler);

    this.consultPreviewUrl = function (consultid) {
      return `/routes/fop/consult/false/false/${consultid}`;
    };

    this.consultPrint = function (consultid) {
      let url = `/routes/fop/consult/true/true/${consultid}`;
      return $http.get(url);
    };

    this.consultPersist = function (consultid) {
      let url = `/routes/fop/consult/false/true/${consultid}`;
      return $http.get(url);
    };

    // Prescription
    // router.get("/" + model + "/prescription/:isprint/:ispersist/:patientid").blockingHandler(this::prescriptionHandler);

    this.prescriptionPreviewUrl = function (patientid) {
      return `/routes/fop/prescription/false/false/${patientid}`;
    };

    this.prescriptionPrint = function (patientid) {
      let url = `/routes/fop/prescription/true/true/${patientid}`;
      return $http.get(url);
    };

    this.prescriptionPersist = function (patientid) {
      let url = `/routes/fop/prescription/false/true/${patientid}`;
      return $http.get(url);
    };

    // Cart/InvoiceReminder
    // invoice printing is realised by CashInvoice and CheckInvoice handlers

    // router.get("/" + model + "/cart/:isprint/:ispersist/:cartid").blockingHandler(this::cartHandler);

    this.cartPreviewUrl = function (cartid) {
      $log.debug('cartPreviewUrl called');
      return `/routes/fop/cart/false/false/${cartid}`;
    };

    // router.get("/" + model + "/reminder/:isprint/:ispersist/:checkinvoiceid").blockingHandler(this::reminderHandler);
    this.reminderPrint = function (checkinvoiceid) {
      let url = `/routes/fop/reminder/true/true/${checkinvoiceid}`;
      return $http.get(url);
    };

    this.reminderPersist = function (checkinvoiceid) {
      let url = `/routes/fop/reminder/false/true/${checkinvoiceid}`;
      return $http.get(url);
    };

    // router.post("/" + model + "/plainjson/:isprint/:ispersist/:patientid/:doctype").blockingHandler(this::plainJsonHandler);
    this.jsonPrint = function (patientid, doctype, json) {
      let url = `/routes/fop/plainjson/true/true/${patientid}/${doctype}`;
      return $http.post(url, json);
    };

    this.jsonPersist = function (patientid, doctype, json) {
      let url = `/routes/fop/plainjson/false/true/${patientid}/${doctype}`;
      return $http.post(url, json);
    };

    this.jsonPreviewUrl = function (patientid, doctype, json) {
      let url = `/routes/fop/plainjson/false/false/${patientid}/${doctype}`;
      return $http.post(url, json);
    };

  }

// klammerfriedhof
}());
